<div class="UserTempPasswordDialogClass">
  <div class="user-temp-password-dialog-header">Временный пароль выдан</div>
  <div class="user-temp-password-dialog-body">
    <p
      >Пароль показывается один раз. Передайте его пользователю до закрытия
      окна.</p
    >
    <mt-field class="user-temp-password-dialog-form-field-input">
      <mt-input
        id="temporary-password"
        type="password"
        [readonly]="true"
        [withShowIcon]="true"
        [value]="data.temporaryPassword"
        autocomplete="off"></mt-input>
      <label for="temporary-password">Временный пароль</label>
    </mt-field>
    <p
      >Действует до {{ data.expiresAt | moscowDateTime }}
      <app-moscow-time-zone-badge />. При входе потребуется смена пароля.</p
    >
    @if (message()) {
      <p role="status">{{ message() }}</p>
    }
  </div>
  <div class="user-temp-password-dialog-footer">
    <mt-button
      title="Скопировать"
      (OnClick)="copy()"></mt-button>
    <mt-button
      title="Закрыть"
      (OnClick)="dialog.close()"></mt-button>
  </div>
</div>
